module.exports = __webpack_public_path__ + "img/exclamation-triangle.402776.svg";